// components/ErrorBoundary.jsx
import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err, info) { console.error(err, info); }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <h3>Something went wrong</h3>
          <p>Please refresh. If the issue persists, call us: <a href="tel:+201123979549">+20 112 397 9549</a></p>
        </div>
      );
    }
    return this.props.children;
  }
}
